export default __webpack_public_path__ + "static/gatsby_deploy_to_main-6e742f35f6d7de813e15b14972808544.png";